import { Row, Col, Button, Space, Typography } from "antd"
import {
  CalendarOutlined,
  FilterOutlined,
  PlusOutlined
} from "@ant-design/icons"
const { Title, Text } = Typography

const Header = () => {
  return (
    <Row justify="space-between" align="middle" style={{ marginBottom: "24px" }}>
          <Col>
            <Title level={2} style={{ margin: 0 }}>
              Financial Command Center
            </Title>
            <Text type="secondary">Execution-driven financial intelligence powered by Radar+</Text>
          </Col>
          <Col>
            <Space>
              <Button icon={<CalendarOutlined />}>Q2 2024</Button>
              <Button icon={<FilterOutlined />}>Filters</Button>
              <Button type="primary" icon={<PlusOutlined />}>
                New Alert
              </Button>
            </Space>
          </Col>
        </Row>
  )
}

export default Header